import routes from './routes.json';

export const protectedRoutes = [
  routes.availLoan,
  routes.pledge,
  routes.repayment,
  routes.accountSettings,
  routes.sellGoldLanding,
  routes.sellGoldCheckout,
  routes.manageSIP,
  routes.buyGoldLanding,
  routes.giftGoldLanding,
  routes.loanProfile,
  routes.loanTopUp,
  routes.releaseLoan,
  routes.loanTopUp,
  routes.releaseAppointment,
  routes.forexBuy,
  routes.forexSell,
  routes.forexReloadCard,
  routes.forexUnloadCard,
  routes.forexSendMoneyAbroad,
  routes.forexCurrencyRequest,
  routes.ncdApply,
  routes.ncdReview,
  routes.ncdStatus,
  routes.billsGst,
  // routes.billsLanding,
  // routes.billsRent,
  // routes.billsVendors,
  routes.billsPaymentStatus,
];
